__turbopack_context__.v({
  "B2BConsumptionForm": "o5WBJq_B2BConsumptionForm",
  "Card": "o5WBJq_Card",
  "Headline": "o5WBJq_Headline",
});
